/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.message[_ngcontent-%COMP%]{padding:10px 10px 0}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#818ea3;font-size:16px}"];
export { styles as styles };
